import { rawApi as api } from '../utils/apiWithLogging';

export interface RentalNote {
  id: number;
  rental_id: number;
  note: string;
  note_type: 'GENERAL' | 'MAINTENANCE' | 'PAYMENT' | 'DELIVERY' | 'RETURN' | 'OTHER';
  created_by_user_id: number;
  created_at: string;
  updated_at: string;
  created_by_username?: string;
  created_by_fullname?: string;
}

export interface RentalNoteCreate {
  note: string;
  note_type: 'GENERAL' | 'MAINTENANCE' | 'PAYMENT' | 'DELIVERY' | 'RETURN' | 'OTHER';
}

export interface RentalNoteUpdate {
  note?: string;
  note_type?: 'GENERAL' | 'MAINTENANCE' | 'PAYMENT' | 'DELIVERY' | 'RETURN' | 'OTHER';
}

class RentalNoteService {
  async getRentalNotes(rentalId: number): Promise<RentalNote[]> {
    const response = await api.get(`/rentals/${rentalId}/notes`);
    return response.data;
  }

  async createRentalNote(rentalId: number, data: RentalNoteCreate): Promise<RentalNote> {
    const response = await api.post(`/rentals/${rentalId}/notes`, data);
    return response.data;
  }

  async updateRentalNote(noteId: number, data: RentalNoteUpdate): Promise<RentalNote> {
    const response = await api.put(`/rentals/notes/${noteId}`, data);
    return response.data;
  }

  async deleteRentalNote(noteId: number): Promise<void> {
    await api.delete(`/rentals/notes/${noteId}`);
  }
}

export default new RentalNoteService();